export default {
      id: "icon-media-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-media",
      toString: function () {
        return this.url;
      }
    }